import React, { useContext, useRef, useState } from "react";
import authService from "../../services/auth.service";
import { AppContext } from "../../context/AppContext";
import { useLocation } from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  FormLabel,
  Row,
} from "react-bootstrap";
import OTPInput, { ResendOTP } from "otp-input-react";

const Login = () => {
  const location = useLocation();

  // Access the search property from the location object
  const queryString = location.search;

  // Use a helper function to parse the query string into an object
  const queryParams = new URLSearchParams(queryString);

  console.info(location, queryString, queryParams);
  const [setLoaderActive, toast, myConfirm] = useContext(AppContext);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState({
    otp: { otp: "", utime: 0 },
    login_input: "",
    contact_value: "",
    contact_type: "",
  });
  const submitLoginForm = async (event) => {
    event.preventDefault();
    const formElement = document.querySelector("#loginForm");
    const formData = new FormData(formElement);
    const formDataJSON = Object.fromEntries(formData);
    const btnPointer = document.querySelector("#login-btn");
    btnPointer.innerHTML = "Please wait..";
    btnPointer.setAttribute("disabled", true);
    try {
      setLoaderActive(true);
      const response = await authService.login(formDataJSON);
      if (!response) {
        toast.error("Login failed");
      } else {
        window.location = queryParams.get("href") || "/";
        // navigate("/patient");
      }
    } catch (ex) {
      console.error("Login error:", ex);
      toast.error("Something went wrong!");
    } finally {
      setLoaderActive(false);
      btnPointer.innerHTML = "Login";
      btnPointer.removeAttribute("disabled");
    }
  };

  const verifyOtp = async () => {
    // event.preventDefault();

    const btnPointer = document.querySelector("#submit-button");
    btnPointer.innerHTML = "Please wait..";
    btnPointer.setAttribute("disabled", true);
    try {
      setLoaderActive(true);
      const response = await authService.verify_otp(otp);
      if (!response) {
        toast.error("Login failed");
      } else {
        window.location = "/";
        // navigate("/patient");
      }
    } catch (ex) {
      console.error("Login error:", ex);
      toast.error("Something went wrong!");
    } finally {
      setLoaderActive(false);
      btnPointer.innerHTML = "Login";
      btnPointer.removeAttribute("disabled");
    }
  };

  const getOtp = async (event) => {
    const btnPointer = document.querySelector("#submit-button");
    const innerhtml = btnPointer.innerHTML;
    btnPointer.innerHTML = "Please wait..";
    btnPointer.setAttribute("disabled", true);
    try {
      setLoaderActive(true);
      const response = await authService.getOtp(otp.login_input);
      if (!response.success) {
        toast.error(response.response);
      } else {
        setOtp(response.response);
        setOtpSent(true);
      }
    } catch (ex) {
      console.error("Login error:", ex);
      toast.error("Something went wrong!");
    } finally {
      setLoaderActive(false);
      btnPointer.innerHTML = innerhtml;
      btnPointer.removeAttribute("disabled");
    }
  };
  return (
    <React.Fragment>
      <Container className="my-5">
        <h2 className="fw-normal mb-5">Login To KAPID</h2>
        <Row>
          <Col md={{ span: 5 }}>
            <Form id="loginForm" onSubmit={submitLoginForm}>
              <FormGroup className="mb-3">
                <FormLabel htmlFor={"login-username"}>Username</FormLabel>
                <input
                  type={"text"}
                  className="form-control"
                  id={"login-username"}
                  name="username"
                  required
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <FormLabel htmlFor={"login-password"}>Password</FormLabel>
                <input
                  type={"password"}
                  className="form-control"
                  id={"login-password"}
                  name="password"
                  required
                />
              </FormGroup>
              <Button type="submit" className="btn-success mt-2" id="login-btn">
                Login
              </Button>
            </Form>
          </Col>
          {!otpSent && (
            <Col md={{ span: 5, offset: 2 }}>
              <FormGroup className="mb-3">
                <FormLabel htmlFor={"login-input"} className="transform-none">
                  Mobile, Email, or KAPID Id
                </FormLabel>
                <input
                  type={"text"}
                  className="form-control"
                  id={"login-input"}
                  name="login_input"
                  value={otp.login_input}
                  required
                  onChange={({ target }) => {
                    setOtp({ ...otp, login_input: target.value });
                  }}
                />
              </FormGroup>
              <Button
                type="submit"
                className="btn-success mt-2"
                id="submit-button"
                onClick={(e) => {
                  getOtp(e);
                }}
              >
                Get OTP
              </Button>
            </Col>
          )}
          {otpSent && (
            <Col md={{ span: 5, offset: 2 }}>
              <p>
                Otp sent to <strong>{otp.contact_value}</strong>!{" "}
                <Button variant="link" onClick={() => setOtpSent(false)}>
                  Change!
                </Button>
              </p>
              <FormGroup className="mb-3">
                <FormLabel className="transform-none">OTP</FormLabel>
                <OTPInput
                  value={otp.otp.otp}
                  onChange={(v) => {
                    setOtp({ ...otp, otp: { otp: v, utime: otp.otp.utime } });
                  }}
                  autoFocus
                  OTPLength={6}
                  otpType="number"
                  disabled={false}
                  secure
                />
                <ResendOTP
                  onResendClick={(e) => {
                    getOtp(e);
                  }}
                />
              </FormGroup>
              <Button
                type="submit"
                className="btn-success mt-2"
                id="submit-button"
                onClick={() => verifyOtp()}
              >
                Verify
              </Button>
            </Col>
          )}
        </Row>
      </Container>
    </React.Fragment>
  );
};
export default Login;
